module.exports = __webpack_public_path__ + "calendar-new.svg?b879ae17e9ff39b105fd34f8116e05c4";